var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rows segment-item-wrapper",
      class: { selected: _vm.selected },
    },
    [
      _c(
        "div",
        { staticClass: "row segment-list", on: { click: _vm.toggleCheckbox } },
        [
          _c(
            "span",
            [
              _c("a-checkbox", {
                staticClass: "segment-checkbox",
                attrs: { checked: _vm.isChecked },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "segment-item" }, [
            _c("div", { staticClass: "segment-item-name" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.row.name) + "\n            "
              ),
            ]),
            _vm._v(" "),
            _c("div", {}, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    !!_vm.row.users ? _vm.row.users.length + " users" : ""
                  ) +
                  "\n            "
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }